"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TextWrapper = exports.StyledTextWithHtml = exports.Root = void 0;
var _mui = require("@ori-ui/mui");
var _presentationComponents = require("@ori/presentation-components");
const Root = exports.Root = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: theme.spacing(3, 0),
        [theme.breakpoints.up('md')]: {
            maxWidth: 550
        }
    };
});
const TextWrapper = exports.TextWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        overflow: 'hidden',
        display: 'flex',
        textAlign: 'left',
        flexDirection: 'column',
        [theme.breakpoints.down('md')]: {
            padding: theme.spacing(0, 3)
        },
        '&:empty': {
            display: 'none'
        }
    };
});
const StyledTextWithHtml = exports.StyledTextWithHtml = (0, _mui.styled)(_presentationComponents.TextWithHtml)((param)=>{
    let { theme } = param;
    return {
        marginBottom: theme.spacing(2),
        color: theme.palette.text.secondary,
        overflow: 'hidden',
        '&:last-child': {
            marginBottom: 0
        }
    };
});
